export default "__VITE_ASSET__DPSEAH1u__"